import { PayloadAction } from '@reduxjs/toolkit';
import { AIModelEnum } from 'src/components/SelectAIModel/SelectAIModel';

export type AiModelAction = PayloadAction<AIModelEnum, 'ai-model/select'>;

export const handleAiModel = (aiModel: AIModelEnum): AiModelAction => ({
	type: 'ai-model/select',
	payload: aiModel
});
